import { defineStore } from 'pinia'
import { request } from '../../api'

export const useSurfaceDesignTexturesStore = defineStore('surfaceDesignTextures', {
  state: () => ({
    list: null,
    count: -1,
    items: null,
    itemsCount: -1,
    collectionsParams: {
      limit: 20,
      offset: 0,
      q: '',
      personal: 1,
      sortDirection: 'asc',
      sortField: 'updatedAt',
    },
    itemsParams: {
      limit: 20,
      offset: 0,
      q: '',
      sortDirection: 'asc',
      sortField: 'updatedAt',
      collection: '',
    },
    createModal: false,
    renameModal: false,
    delCollectionModal: false,
    delTeamCollectionModal: false,

    renameItemModal: false,
    delItemModal: false,

    collectionName: '',
    collectionId: null,

    itemName: '',
    itemId: null,
    changeItem: null,

    selectedCollectionId: null,
    selectedCollectionName: null,
    selectedCollection: null,
    oneCollection: null,

    loading: false,
    textureFiles: [],
    collumnCount: null,

    deletedItems: [],
  }),
  getters: {
    canSave: (state) => {
      const noName = state.textureFiles?.find(el => el.imgUrl && !el.name)
      if (noName) return false
      const isNew = !!state.textureFiles?.find(el => el.imgUrl && !el.id && !el.error) || state.deletedItems.length
      let isOld = false
      state.textureFiles.forEach(el => {
        if (el.id && state.items) {
          const texture = state.items.find(e => e.id === el.id)
          let name = texture?.name || ''
          if ((el.name !== name || el.imgUrl) && !el.error) isOld = true
        }
      })
      return isNew || isOld
    },
  },
  actions: {
    makeImgArray () {
      console.log('ok')
      const isNotFull = this.textureFiles.find(el => !el.imgUrl && !el.url)
      console.log('isNotFull', isNotFull)
      if (this.items && !isNotFull && !this.textureFiles.length) {
        this.items.forEach(el => {
          this.textureFiles.push({
            id: el.id,
            name: el.name,
            url: el.url,
            error: null,
            imgUrl: null,
          })
        })
      }
      if (!this.textureFiles.length || !isNotFull) {
        const remainder = this.textureFiles.length % this.collumnCount
        const needCount = remainder === 0 ? this.collumnCount : this.collumnCount - remainder
        this.textureFiles.push(
          ...Array(needCount).fill(null).map(() => ({ imgUrl: null, name: '', error: null, id: null })),
        )
      }
    },
    addTextureImg (event, index) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.textureFiles = [...this.textureFiles]
          let id = this.textureFiles[index].id ? this.textureFiles[index].id : null
          this.textureFiles[index] = {
            imgUrl: e.target.result,
            name: this.textureFiles[index]?.name || '',
            url: this.textureFiles[index]?.url,
            error: null,
            id: id,
            file,
          }
          this.makeImgArray()
        }
        reader.readAsDataURL(file)
      }
    },
    selectCollectionId (collectionId) {
      this.selectedCollectionId = collectionId
    },
    selectCollection (collection) {
      this.selectedCollection = collection
    },
    createModalToggle () {
      this.createModal = !this.createModal
      this.collectionName = ''
    },
    renameModalToggle () {
      this.renameModal = !this.renameModal
      this.collectionId = null
      this.collectionName = ''
    },
    delCollectionModalToggle () {
      this.delCollectionModal = !this.delCollectionModal
      this.collectionId = null
    },
    renameItemModalToggle () {
      this.renameItemModal = !this.renameItemModal
      this.itemId = null
      this.itemName = ''
    },
    delItemModalToggle () {
      this.delItemModal = !this.delItemModal
      this.itemId = null
    },
    async setSortOrderCollections (order) {
      this.collectionsParams.sortDirection = order
      await this.getList()
    },
    async searchByCollections (search) {
      this.collectionsParams.q = search
      this.collectionsParams.offset = 0
      await this.getList()
    },
    async sortCollection (sort) {
      this.collectionsParams.sortField = sort
      this.collectionsParams.offset = 0
      await this.getList()
    },
    async setSortOrderItems (order, id) {
      this.itemsParams.sortDirection = order
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async searchByItems (search, id) {
      this.itemsParams.q = search
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async sortItems (sort, id) {
      this.itemsParams.sortField = sort
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async getList () {
      this.loading = true
      try {
        const { data: { rows: list, count } } = await request.get(
          '/surface/textures-collections',
          { params: this.collectionsParams },
        )
        this.list = list
        this.count = count
        this.loading = false
      } catch (e) {
        console.error(e.message)
        this.loading = false
      }
    },
    async getCollection (id) {
      try {
        const { data } = await request.get('/surface/textures-collections/' + id)
        this.oneCollection = data
      } catch (e) {
        console.error(e.message)
      }
    },
    async dellTextureImg (index) {
      const updatedFiles = [...this.textureFiles]
      if (updatedFiles[index].id) this.deletedItems.push(updatedFiles[index].id)
      updatedFiles[index] = { imgUrl: null, name: '', error: null, id: null }
      this.textureFiles = updatedFiles
      this.makeImgArray()
    },
    async saveTextures (router) {
      this.loading = true
      if (this.deletedItems.length) {
        await request.delete(`/surface/textures/${this.deletedItems[0]}`)
        this.deletedItems.splice(0, 1)
        this.saveTextures(router)
        return
      }
      for (let index = 0; index < this.textureFiles.length; index++) {
        const item = this.textureFiles[index]
        if (item.file && !item.id) {
          const form = new FormData()
          form.append('name', item.name)
          form.append('file', item.file)
          form.append('collection', this.selectedCollectionId)

          await request.post('/surface/textures',
            form,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              transformRequest: [(data) => data],
            })
            .then(response => {
              const updatedFiles = [...this.textureFiles]
              updatedFiles[index] = {
                ...updatedFiles[index],
                id: response.data.id,
              }
              this.textureFiles = updatedFiles
            })
            .catch(error => {
              const updatedFiles = [...this.textureFiles]
              updatedFiles[index] = {
                ...updatedFiles[index],
                error: error.response.data.message,
              }
              this.textureFiles = updatedFiles
            })
        } else if (item.id) {
          const texture = this.items?.find(el => el.id === item.id)
          if (item.file || item?.name !== texture?.name) {
            const form = new FormData()
            if (item.file) form.append('file', item.file)
            if (item?.name !== texture?.name) form.append('name', item.name)
            await request.put('/surface/textures/' + item.id,
              form,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
                transformRequest: [(data) => data],
              })
              .catch(error => {
                const updatedFiles = [...this.textureFiles]
                updatedFiles[index] = {
                  ...updatedFiles[index],
                  error: error.response.data.message,
                }
                this.textureFiles = updatedFiles
                console.error('Error:', error)
              })
          }
        }
      }
      const isError = this.textureFiles.find(el => el.error)
      this.loading = false
      if (!isError) router.push(`/user/surface-design-texture/${this.selectedCollectionId}`)
    },
    clearFiles () {
      this.textureFiles = []
      this.items = null
    },
    async create (router) {
      try {
        const response = await request.post(
          '/surface/textures-collections',
          JSON.stringify({ title: this.collectionName }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        this.createModalToggle()
        this.getList()
        this.selectedCollectionId = response.data.id
        this.selectedCollectionName = response.data.title
        this.clearFiles()
        router.push({ name: 'surfaceDesignTextureNew' })
      } catch (e) {
        console.error(e.message)
      }
    },
    async updateCollection () {
      try {
        await request.put(
          '/surface/textures-collections/' + this.collectionId,
          JSON.stringify({ title: this.collectionName }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        await this.getList()
        this.renameModalToggle()
        this.collectionId = null
        this.collectionName = ''
      } catch (e) {
        console.error(e.message)
      }
    },
    async deleteCollection () {
      try {
        await request.delete('/surface/textures-collections/' + this.collectionId)
        await this.getList()
        this.delCollectionModalToggle()
        this.collectionId = null
      } catch (e) {
        console.error(e.message)
      }
    },

    async getItems (id) {
      this.items = null
      this.itemsCount = 0
      try {
        this.itemsParams.collection = id
        const { data: { rows: items, count } } = await request.get(
          '/surface/textures',
          { params: this.itemsParams },
        )
        this.items = items
        this.itemsCount = count
      } catch (e) {
        console.error(e.message)
      }
    },

    async updateItem (collectionId) {
      try {
        await request.put(
          '/surface/textures/' + this.itemId,
          JSON.stringify({
            ...this.changeItem,
            designName: this.designName,
            designCategory: this.changeItem.categoryCode,
            elementIds: this.changeItem.elements.join(','),
            ease: JSON.stringify(this.changeItem.ease),
            fabricType: String(this.changeItem.fabricType),
            fit: String(this.changeItem.fit),
            collectionId: String(this.changeItem.collection),
            mannequinEase: JSON.stringify(this.changeItem.mannequinEase),
          }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        await this.getItems(collectionId)
        this.renameItemModalToggle()
        this.itemId = null
        this.itemName = ''
      } catch (e) {
        console.error(e.message)
      }
    },
    async deleteItem (collectionId) {
      try {
        await request.delete('/surface/textures/' + this.itemId)
        await this.getItems(collectionId)
        this.delItemModalToggle()
        this.itemId = null
      } catch (e) {
        console.error(e.message)
      }
    },
  },
})
